import { Toaster } from "@commerce-os/ui";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

import type { AppContext } from "../app/context";
import { useTheme } from "../app/theme";
import { NotFoundPage, RouteErrorPage } from "../features/shell/status-pages";

export const Route = createRootRouteWithContext<AppContext>()({
  component: Root,
  notFoundComponent: NotFoundPage,
  errorComponent: RouteErrorPage,
});

function Root() {
  const theme = useTheme();
  return (
    <>
      <Outlet />
      <Toaster theme={theme} />
    </>
  );
}
